<!-- 一般ユーザー　キャンセル確認-->

<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_mypage.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
  <div class="container">
    <div class="contents">
      <!-- ▽  -->
      <section id="mainContents">
      <!-- 雲財修正 ここから -->
      	<section class="confirmArea">
          <h3>【予約キャンセル】</h3>
          <p>予約をキャンセルする</p>
          <ul class="listMessage">
            <li v-for="item in mem5List" v-bind:key="item">{{item}}</li>
          </ul>
          <div class="btnLst"><button class="backBtn" v-on:click="onBack">マイページへ戻る</button></div>
        </section>
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonConfirmCancel2 } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonConfirmCancel2',
		// 使用コンポーネント
		components: {
			// エラー表示コンポーネント
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ表示コンポーネント
			modalWindow: ModalWindow
		},
    // データ
    data() {
      return {
        
        // キャンセル確定時注意事項リスト
        mem5List: '',

        // モーダルウィンドウ
        modal: {
					// システムエラー
					systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          },
        }
      }
    },
		// ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonConfirmCancel2::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonConfirmCancel2::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      firstDisplay: function () {

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::firstDisplay Start')

        CommonConfirmCancel2.FirstDisplay({
          token: this.$store.state.auth.token,
          ukno: this.$store.state.commonUserInfo.myPage.cancelUkno
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
            this.mem5List = responce.data.mem5List

            // ストア値の変更
 		        this.$store.commit(
 		        	types.COMMON_CONFIRMCANCEL_DECISION)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::firstDisplay End')
	      })
      },
      // 表示系--------------------------------------------------E
      // マイページへ戻るボタン
      onBack: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onBack Start')

        // マイページに遷移
        this.$router.push("/CommonMyPage")

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onBack End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonConfirmCancel2::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ConfirmCancel/CommonConfirmCancel2.vue